import * as yup from 'yup';
import { createConditionalValidator } from 'utils/yup';

const validationSchema = yup.object().shape({
  other_investments_amount: createConditionalValidator('other_investments', 'number'),
  other_investments_comment: createConditionalValidator('other_investments', 'string'),
});

export default validationSchema;
